import React from 'react';
import classname from 'classnames';

import styles from './styles.module.scss';

const CenterContainer = ({ contentBoxClassName, className, children }) => {
    return (
        <div className={classname(styles.container, { [className]: className })}>
            <div className={classname(styles.centeredContentBox, { [contentBoxClassName]: contentBoxClassName })}>
                {children}
            </div>
        </div>
    );
};

export default CenterContainer;
